import {
  Home,
  ReviewUser,
  UserSuccess,
  SelectAccount,
  AddAccount,
  ReviewUserAccount,
  UserSuccessAccount,
  SelectAccountNewUser,
  ReviewUserAccountNewUser,
  EditUser,
  HistoryUser,
  NewUser,
  SearchUsers
} from '@pages/index';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/edit-user/:id" element={<EditUser />} />
        <Route path="/review-user" element={<ReviewUser />} />
        <Route path="/review-user-account" element={<ReviewUserAccount />} />
        <Route path="/review-user-account-new-user" element={<ReviewUserAccountNewUser />} />
        <Route path="/user-success" element={<UserSuccess />} />
        <Route path="/user-success-account" element={<UserSuccessAccount />} />
        <Route path="/select-account" element={<SelectAccount />} />
        <Route path="/select-account-new-user" element={<SelectAccountNewUser />} />
        <Route path="/add-account" element={<AddAccount />} />
        <Route path="/history-user/:id" element={<HistoryUser />} />
        <Route path="/new-user" element={<NewUser />} />
        <Route path="/search-user" element={<SearchUsers />} />
      </Routes>
    </BrowserRouter>
  );
}
